import { render } from "./KycBody.vue?vue&type=template&id=c6484dca"
import script from "./KycBody.vue?vue&type=script&lang=js"
export * from "./KycBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__